import { parseQueryParams } from './url';

export const defaultSearchState = parseQueryParams();
